/** @file commitPoseOverride: turns the pending drag pose into one clip command and clears the override. */
import type { EditorStore } from '../../state/editorTypes';
import { mirrorGuard } from '../timeline/mirrorGuard';
import { poseCommand } from '../timeline/poseCommand';

/**
 * Clears `poseOverride` and, unless its frame is in a mirrorHalf clip's computed half (warning, nothing sent),
 * dispatches one `poseCommand` for its nodes. Returns whether a command was dispatched; no override = no-op.
 */
export function commitPoseOverride(store: EditorStore): boolean {
  const s = store.getState();
  const o = s.poseOverride;
  if (o === null) return false;
  s.setPoseOverride(null);
  const clip = s.puppet.doc?.clips[o.clip];
  if (clip === undefined || mirrorGuard(clip, o.frame, s.notify)) return false;
  void s.dispatch([poseCommand(o.clip, clip, o.frame, o.nodes)], `pose ${Object.keys(o.nodes).join(', ')} @${o.frame}`);
  return true;
}
